import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';

import BoxPictureText, {
  BoxPictureTextProps,
  ImageVariants,
} from '../BannerBoxPictureText/BoxPictureText';

type GridBoxImageTextProps = Omit<BoxPictureTextProps, 'imageVariant'>;

interface GridBoxesImageTextProps {
  _uid: string;
  component: string;
  boxes: GridBoxImageTextProps[];
}

const cssClasses = {
  container: 'grid grid-cols-24 bg-white py-30px lg:py-60px',
  tilesContainer:
    'col-start-2 col-end-24 grid lg:grid-cols-3 grid-cols-1 gap-[15px] lg:gap-[30px]',
};

const GridBoxesImageText = (props: GridBoxesImageTextProps) => {
  const { boxes } = props;
  return (
    <div className={clsx(cssClasses.container)} {...sbEditable(props)}>
      <div className={cssClasses.tilesContainer}>
        {boxes.map((box, index) => {
          const isSecondCol = (index + 2) % 3 === 0;

          return (
            <BoxPictureText
              {...box}
              key={box._uid}
              trackId="grid_box_picture_text_item_click"
              textFirst={isSecondCol}
              contentClassName="p-[20px_30px_30px] lg:p-[30px_30px_30px_40px]"
              imageVariant={ImageVariants.FULL_SURFACE}
              buttonColor={box.headlineColor}
            />
          );
        })}
      </div>
    </div>
  );
};

export default GridBoxesImageText;
